module.exports = __webpack_public_path__ + "static/media/product.be7839f4.jpg";